import { useState } from 'react';
import { useNotify } from '@/context/NotificationContext';
import { adminApi } from '@/utils/api';
import { ConfirmActionModal } from '@/components/Modals/ConfirmActionModal';

export const FundsManager = () => {
    const [userId, setUserId] = useState('');
    const [amount, setAmount] = useState('');
    const { showNotification } = useNotify();
    const [unfreezeConfirm, setUnfreezeConfirm] = useState(false);
    const [isUnfreezing, setIsUnfreezing] = useState(false);

    const handleUnfreezeClick = () => {
        if (!userId || !amount) return showNotification('Error', 'Missing fields', 'error');
        setUnfreezeConfirm(true);
    };

    const executeUnfreeze = async () => {
        setUnfreezeConfirm(false);
        setIsUnfreezing(true);
        try {
            const res = await adminApi.unfreezeFunds({ userId, amount });
            const data = await res.json();
            if (data.success) {
                showNotification('Success', 'Funds Unfrozen!', 'success');
                setUserId('');
                setAmount('');
            } else {
                showNotification('Error', data.error || 'Operation Failed', 'error');
            }
        } catch (e) {
            showNotification('Error', 'Network Error', 'error');
        } finally {
            setIsUnfreezing(false);
        }
    };

    return (
        <div className="space-y-6">
            <h2 className="text-xl font-bold uppercase tracking-widest text-blue-400">Emergency Funds Manager</h2>
            <div className="bg-[#1c1c1e] p-6 rounded-2xl border border-white/5 space-y-4">
                <div className="bg-red-500/10 border border-red-500/20 p-4 rounded-xl text-red-500 text-xs mb-4">
                    <p className="font-bold uppercase mb-1">⚠️ Warning: Admin Action Only</p>
                    <p>Unfreezing funds manually decreases <b>locked_balance</b> and increases <b>available_balance</b>. This action is irreversible and should only be used if a transaction is stuck or disputed.</p>
                </div>
                <div>
                    <label className="text-xs font-bold text-gray-500 uppercase mb-1 block">User ID (Internal ID)</label>
                    <input value={userId} onChange={e => setUserId(e.target.value)} placeholder="e.g. 1" className="w-full bg-black/20 border border-white/5 rounded-xl px-4 py-3 text-white focus:border-blue-500 outline-none" />
                </div>
                <div>
                    <label className="text-xs font-bold text-gray-500 uppercase mb-1 block">Amount to Unfreeze (GRAM)</label>
                    <input type="number" value={amount} onChange={e => setAmount(e.target.value)} placeholder="e.g. 10.5" className="w-full bg-black/20 border border-white/5 rounded-xl px-4 py-3 text-white focus:border-blue-500 outline-none" />
                </div>
                <div className="pt-4">
                    <button onClick={handleUnfreezeClick} disabled={isUnfreezing} className="w-full py-4 bg-blue-600 hover:bg-blue-500 rounded-xl font-black uppercase tracking-widest text-sm transition-all shadow-lg shadow-blue-600/20 active:scale-[0.98] disabled:opacity-50">
                        {isUnfreezing ? 'Releasing...' : 'Release Funds'}
                    </button>
                </div>
            </div>
            <ConfirmActionModal
                isOpen={unfreezeConfirm}
                onClose={() => setUnfreezeConfirm(false)}
                onConfirm={executeUnfreeze}
                title="Unfreeze Funds"
                message={`Are you sure you want to UNFREEZE ${amount} GRAM for user ${userId}?`}
                confirmText={isUnfreezing ? "Processing..." : "Unfreeze"}
                isLoading={isUnfreezing}
                isDanger={true}
            />
        </div>
    );
};
